import { Route, Routes } from "react-router-dom";
import "./App.css";

import Landingpage from "./pages/Landingpage";
import Layout from "./layout/layout";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Landingpage />} />
        </Route>
      </Routes>
      {/*       
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/TU2wk0yUKLher5h" element={<Blogpage />} />
        </Route>
      </Routes> */}
    </>
  );
}

export default App;
